<template>
	<template v-for="main in sidebarMenus.main" :key="'mainmenu_' + main.id">
		<li v-if="main.has_submenu" class="nav-main-item">
			<a
				class="nav-main-link nav-main-link-submenu"
				data-toggle="submenu"
				:aria-haspopup="true"
				:aria-expanded="false"
				href="#"
			>
				<i :class="'nav-main-link-icon fa ' + main.icon"></i>
				<span class="nav-main-link-name">{{ main.sidebar_menu }}
					<span v-if="main.sidebar_menu=='TRC LIVE' && $page.props.has_live>0" class="badge bg-danger ms-2"><i class="fa fa-video me-1"></i>LIVE</span>
				</span>
			</a>
			<ul v-if="main.sidebar_menu=='Affiliate Program' && $page.props.user.consent_status==0" class="nav-main-submenu">
				<li
					class="nav-main-item"
				>
					<inertia-link 
						class="nav-main-link submenu"
						:class="{ active: $page.component == 'Member/AfiiliateProgram/AgreementAndPolicies' }"
						href="/member/affiliate-program/agreement-and-policies"
					>
						<span class="nav-main-link-name">Terms And Policies</span>
					</inertia-link>
				</li>
			</ul>
			<ul v-else class="nav-main-submenu">
				<li
					v-for="sub in sidebarMenus.sub[main.id]"
					:key="'submenu_' + sub.id"
					class="nav-main-item"
				>
					<a v-if="sub.sidebar_submenu === 'Investment'" :href="sub.url" class="nav-main-link submenu" target="_blank">
						<span class="nav-main-link-name">{{ sub.sidebar_submenu }}</span>
						<div v-if="sub.ribbons" v-html="sub.ribbons"></div>	
					</a>
					<inertia-link v-else-if="$page.props.investment!=null && sub.sidebar_submenu=='Member Information'"
						class="nav-main-link submenu"
						:class="{ active: (sub.component === $page.component || (sub.sidebar_submenu=='Member Information' && ['Member/Investment/MemberInformation','Member/Investment/RiskProfile'].includes($page.component))) }"
						:href="sub.url"
					>
						<span class="nav-main-link-name">{{ sub.sidebar_submenu }}</span>
						<div v-if="sub.ribbons" v-html="sub.ribbons"></div>
					</inertia-link>
					<inertia-link v-else-if="sub.sidebar_submenu!='Member Information'"
						class="nav-main-link submenu"
						:class="{ active: sub.component === $page.component }"
						:href="sub.url"
					>
						<span class="nav-main-link-name">{{ sub.sidebar_submenu }}</span>
						<div v-if="sub.ribbons" v-html="sub.ribbons"></div>
					</inertia-link>
				</li>
			</ul>
		</li>
		<li v-else class="nav-main-item">
			<inertia-link
				class="nav-main-link"
				:class="{ active: main.component === $page.component }"
				:href="main.url"
			>
				<span :class="'nav-main-link-icon fa ' + main.icon"></span>
				<span class="nav-main-link-name">{{ main.sidebar_menu }}
					<span v-if="main.sidebar_menu=='Events' && $page.props.has_zoom_live>0" class="badge bg-danger ms-2"><i class="fa fa-video me-1"></i>LIVE</span>
				</span>
			</inertia-link>
		</li>
	</template>
</template>

<script>
export default {
	props: {
		sidebarMenus: Object,
	},
}
</script>
